import React from "react";
import Dashboard from "../component/Dashboard";

const UserDashboard = () => (
  <div>
    <Dashboard />
  </div>
);

export default UserDashboard;
